var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz_bt_area"},[_c('button',{staticClass:"quiz_bt close_bt",on:{"click":function($event){$event.preventDefault();return _vm.clickHandler($event)}}},[_c('span',[_vm._v("とじる")])])])}
var staticRenderFns = []

export { render, staticRenderFns }